import { Typography } from "@mui/material";
import { Dialog } from "../../components/dialogs/Dialog";
import { useLocale } from "../../providers/LocaleProvider";

const ImportTaskListConfirmDialog = (props: any) => {
  const {
    theme,
    onClose,
    open = false,
    onImport = () => {},
    tasks = [],
    isLoading = false,
    isMultiTasks
  } = props;
  const { translate } = useLocale();

  return (
    <Dialog
      open={open}
      theme={theme}
      onClose={onClose}
      fullWidth={true}
      maxWidth='sm'
      title={translate("settings.importCompetencies")}
      actions={[
        {
          label: translate("settings.confirmAndImport"),
          primary: true,
          variant: "filled",
          disabled: isLoading,
          onClick: onImport,
          isLoading: isLoading
        },
        {
          label: translate("common.cancel"),
          onClick: onClose
        }
      ]}
    >
      <Typography>
        {translate(
          isMultiTasks
            ? "settings.importCompetenciesMessageMultiple"
            : "settings.importCompetenciesMessageSingle"
        )}
      </Typography>

      <ul>
        {tasks.map((task: any) => (
          <li key={task.id}>
            <Typography>{task.name}</Typography>
          </li>
        ))}
      </ul>
    </Dialog>
  );
};

export default ImportTaskListConfirmDialog;
